<template>
    <div>
        <div class="icon-center" @click.stop="showCenter">
            <van-icon name="contact-o" />
            <span v-if="userInfo.studentName">{{userInfo.studentName}}</span>
        </div>
        <div class="content" v-show="show">
            <div class="bannerTitle">
                <div class="logoImg">
                    <div class="headMessage">
                        <div class="imghead">
                            <img :src="userInfo.avatar != '' ? userInfo.avatar : headimg" alt="">
                        </div>
                        <div class="message">
                            <div class="name">
                                <span>{{ userInfo.studentName }} </span>
                                <span v-if="userInfo.gender == 1">(男)</span>
                                <span v-if="userInfo.gender == 2">(女)</span>
                            </div>
                            <div class="phone">
                                <span>手机：{{ userInfo.telphone }}</span>
                            </div>
                            <div class="card">
                                <span>身份证号：{{ userInfo.idcard }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="school-box">
                    <div class="school-item">
                        <span>报考院校：</span>
                        <span>{{ `${userInfo.examOrgName}（${userInfo.examOrgCode}）`}}</span>
                    </div>
                    <div class="school-item">
                        <span>报考专业：</span>
                        <span>{{ `${userInfo.examMajorName}（${userInfo.examMajorCode}）`}}</span>
                    </div>
                    <div class="school-item">
                        <span>准考证号：</span>
                        <span>{{ userInfo.examNum || "-" }}</span>
                    </div>
                </div>
            </div>
            <div style="padding: 0.30rem 0.4rem">
                <van-button @click="logout" type="info" block>退出登录</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import apis from './apis'
export default {
    data() {
        return {
            show: false,
        }
    },
    computed: {
        userInfo(){
            return this.$root.userInfo
        }
    },
    mounted() {
        document.body.addEventListener('click', _ => {
            this.show = false
        })
    },
    methods: {
        showCenter() {
            let user_id = localStorage.getItem('user_id')
            if (!user_id) return this.$notify({ type: 'warning', message: '请先登录' })
            this.show = true
        },
        logout() {
            this.$dialog.confirm({
                title: '提示',
                message: '是否退出登录',
                confirmButtonColor: '#1989fa'
            }).then(async _ => {
                await apis.logout()
                localStorage.clear()
                this.$root.userInfo = {}
                this.$router.push('/login')
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.icon-center {
    position: fixed;
    top: 10px;
    right: 10px;
    cursor: pointer;
    font-size: 22px;
    // width: 40px;
    height: 40px;
    // border-radius: 50%;
    border-radius: 40px;
    padding: 0 10px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
        font-size: 14px;
        padding: 0 4px;
    }
}
.content {
    font-size: 14px;
    box-sizing: border-box;
    background: linear-gradient(to bottom, #c0daf1, #f0f0f0 50%, #fff);
    // background-color: #fff;
    padding: 0 0.2rem;
    position: fixed;
    top: 20px;
    right: 20px;
    border-radius: 20px;
    .school-box {
        padding: 0 0.25rem;
        .school-item {
            padding: 0.1rem 0;
            display: flex;
            align-items: center;
            vertical-align: top;
            span:nth-child(2n + 1) {
                vertical-align: -2px;
                color: #666666;
            }
        }
    }
}
.bannerTitle {
    height: 70%;
    padding: 0.2rem 0 0.1rem;
    letter-spacing: 0.05em;
    position: relative;
    margin-bottom: 0.1rem;
    border-radius: 0 0 0.1rem 0.1rem;
    .logoImg {
        width: 100%;
        padding: 0rem 0.2rem;
        box-sizing: border-box;
        position: relative;
        .tag {
            color: #407ded;
            background-color: #dbe1ed;
            border-radius: 0.1rem;
            padding: 0.1rem 0.2rem;
            position: absolute;
            right: 0.2rem;
            top: 0.1rem;
        }
        .headMessage {
            display: flex;
            align-items: center;
            margin-bottom: 0.13rem;
            .imghead {
                width: 70px;
                height: 100px;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                    border-radius: 0.1rem;
                    width: 100%;
                }
            }
            .message {
                height: 100px;
                margin-left: 0.2rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                box-sizing: border-box;
                padding: 0.1rem 0;
                align-items: flex-start;
                .name {
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #333333;
                }
                .phone {
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #666666;
                }
                .card {
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #666666;
                }
            }
        }
    }
}
</style>